// extracted by mini-css-extract-plugin
export var label = "_eh-5";
export var slideContainer = "_eh-0";
export var slider = "_eh-1";
export var sliderLg = "_eh-4";
export var sliderMd = "_eh-3";
export var sliderSm = "_eh-2";